var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictoChaud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43.32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "chaud") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_206",
    "data-name": "Groupe 206"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_219",
    "data-name": "Trac\\xE9 219",
    className: "cls-1",
    d: "M2,32c-3.65-4.44-1.74-8.7.9-13.44C8.23,9,8.06,8,1.25,0h0C11,5.26,11.46,10.56,5.33,20h0C1.89,25.34,1.13,26.05,2,32Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_220",
    "data-name": "Trac\\xE9 220",
    className: "cls-1",
    d: "M19,32c-3.64-4.44-1.73-8.7.9-13.44C25.2,9,25,8,18.23,0h0C28,5.26,28.44,10.56,22.31,20h0C18.87,25.34,18.1,26.05,19,32Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_221",
    "data-name": "Trac\\xE9 221",
    className: "cls-1",
    d: "M36,32c-3.64-4.44-1.74-8.7.9-13.44C42.18,9,42,8,35.21,0h0c9.73,5.26,10.21,10.56,4.08,20h0C35.85,25.34,35.08,26.05,36,32Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoChaud);
export default __webpack_public_path__ + "static/media/picto-chaud.cc1de19c3a0cc7c8f160eb6c1af02f2f.svg";
export { ForwardRef as ReactComponent };